import { EngagementDefinition } from '../base/EngagementDefinition';
import { StageVoteForEngagement } from './stage/stage-view';
import { FanVoteForEngagement } from './fan/mobile-view';
import {
  EngagementType,
  VoteForAdminConfig,
  VoteForAdminData,
} from '@/generated/graphql';
import { VoteForAdminControlView } from './admin/control-view';
import { BarChartIcon } from '@radix-ui/react-icons';
import { VoteForEditorView } from './admin/editor-view';

export const voteForEngagementDefinition: EngagementDefinition<
  VoteForAdminConfig,
  VoteForAdminData
> = {
  enabled: true,
  title: 'Live Poll',
  Icon: BarChartIcon,
  type: EngagementType.VoteFor,
  stageComponent: StageVoteForEngagement,
  fanComponent: FanVoteForEngagement,
  adminEditorView: VoteForEditorView,
  adminControlView: VoteForAdminControlView,
  getInitialData: () => ({
    votes: [],
    choiceDisplayOrder: [],
  }),
  getInitialConfig: () => ({
    allowUserSubmissions: false,
    votesPerUser: 1,
    maxSubmissionsPerUser: 1,
  }),
};
